<template>
    <div>
        Emisiones IMSS
    </div>
</template>

<script>
export default {
    
}
</script>